import { ArtistDetails } from '@/modals/artist/ArtistDetails';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '@services/app.service';
import { EncryptionService } from '@services/encryption.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-artist',
  templateUrl: './artist.component.html',
  styleUrls: ['./artist.component.scss']
})
export class ArtistComponent implements OnInit {

  artists:ArtistDetails[]=[];
  encryptedId: string | null = null;
  router: Router;

  constructor(
    private appService: AppService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    router: Router,
    private route: ActivatedRoute,
    private encryptionService: EncryptionService
  ) {
    this.router = router;
  }

  ngOnInit(): void {
    const encryptedIdParam = this.route.snapshot.paramMap.get('id');
    this.encryptedId = encryptedIdParam;

    if (encryptedIdParam) {
      try {
        const decryptedId = this.encryptionService.decrypt(decodeURIComponent(encryptedIdParam));
        this.loadArtistDetail(Number(decryptedId));
      } catch (error) {
        console.error('Error decrypting artist ID:', error);
        this.getAllArtistDetails();
      }
    } else {
      this.getAllArtistDetails();
    }
  }

  getAllArtistDetails(){
    this.spinner.show();
    this.appService.getAllArtists().subscribe({
      next: (data) => {
        this.artists = data.sort(
          (a: any, b: any) => b.artistDetailsId - a.artistDetailsId
        );
      },
      error: (err) => {
        console.error('Error loading Artists:', err);
      },
      complete: () => {
        this.spinner.hide();
        // Any finalization logic can go here
      },
    });
  }

  loadArtistDetail(artistId: number): void {
    this.spinner.show();
    this.appService.getAllArtists().subscribe({
      next: (data) => {
        const artist = data.find(a => a.artistDetailsId === artistId);
        if (artist) {
          this.artists = [artist];
        } else {
          this.toastr.error('Artist not found');
          this.router.navigate(['/main/artist']);
        }
      },
      error: (err) => {
        console.error('Error loading artist detail:', err);
        this.toastr.error('Unable to load artist details');
        this.router.navigate(['/main/artist']);
      },
      complete: () => {
        setTimeout(() => this.spinner.hide(), 2000);
      },
    });
  }

  viewArtist(artistDetailsId: number): void {
    const encryptedId = this.encryptionService.encrypt(artistDetailsId.toString());
    this.router.navigate(['/main/artist', encodeURIComponent(encryptedId)]);
  }
}
